import React from "react";
import PropTypes from "prop-types";
import { Modal, FormControl } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import AlmigButton from "../grundelemente/AlmigButton";

import WillkommenContainer from "./WillkommenContainer";
import "./WillkommenLogin.css";

class WillkommenLogin extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.handleChange = this.handleChange.bind(this);
		this.submit = this.submit.bind(this);
		this.state = {
			password: "",
			request_pending: false
		};
	}
	handleChange(e) {
		this.setState({ password: e.target.value });
	}
	submit() {
		let self = this;
		fetch("/login", {
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify(this.state)
		}).then(response => {
			if (response.ok) {
				response.json().then(
					authorization => self.props.loginSuccess(authorization));
			} else {
				/* loginFailed() -> bisher keine sichtbare Auswirkung */
			}
			self.setState({ request_pending: false });
		});	/*.catch(error) { loginFailed() } */

		/* Passwort gleich wieder löschen, damit der Dialog bei der nächsten
		 * Eingabe wieder leer ist.
		 */
		this.setState({ password: "", request_pending: true });
	}
	render() {
		let { password, request_pending } = this.state;
		return (
			<div className={classNames({
				"modal-container" : true,
				"almig-show-as-busy": request_pending
			})}>
				{/* erzeugt Warnung, wenn bereits in "/": <Redirect to="/" />*/}
				<WillkommenContainer />
				<Modal show={!this.props.authorized}
					container={this}
					aria-labelledby="contained-modal-title">
					<Modal.Header>
						<Modal.Title id="contained-modal-title">
							<FormattedMessage id="Please enter your password" />
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<FormControl type="text" onChange={this.handleChange}
							onKeyPress={e => { if (e.charCode === 13) this.submit(); }}
							autoFocus={true} value={password}
							disabled={request_pending} />
					</Modal.Body>
					<Modal.Footer>
						<AlmigButton i18n_key="Login" onClick={this.submit}
							disabled={request_pending} />
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
}

WillkommenLogin.propTypes = {
	authorized: PropTypes.bool.isRequired,
	loginSuccess: PropTypes.func.isRequired
};

export default WillkommenLogin;
